/**
 * ODD SLIK — Scroll Reveal & Hero Animations
 * Ultra-minimal, editorial luxury footwear from India
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Intersection Observer — fade-up on scroll
  ------------------------------------------------------------------ */
  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('oddslik-in-view');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
  );

  function initScrollReveal() {
    document.querySelectorAll('.oddslik-fade-up').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ------------------------------------------------------------------
     Hero text — staggered fade-up on page load
  ------------------------------------------------------------------ */
  function initHeroAnimations() {
    var heroBlocks = document.querySelectorAll('.hero-section .content-block, .hero-section [class*="text-block"]');
    heroBlocks.forEach(function (el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(28px)';
      el.style.transition = 'opacity 1.1s cubic-bezier(0.22,1,0.36,1) ' + (i * 0.18) + 's, transform 1.1s cubic-bezier(0.22,1,0.36,1) ' + (i * 0.18) + 's';
      setTimeout(function () {
        el.style.opacity = '';
        el.style.transform = '';
      }, 60);
    });
  }

  /* ------------------------------------------------------------------
     Init
  ------------------------------------------------------------------ */
  function init() {
    initScrollReveal();
    initHeroAnimations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run after Shopify view transitions
  document.addEventListener('shopify:section:load', initScrollReveal);
})();

/* ------------------------------------------------------------------
   ODD SLIK — Preloader (first visit ever only)
------------------------------------------------------------------ */
(function () {
  var el = document.getElementById('osPreloader');
  if (!el) return;

  if (localStorage.getItem('os_preloader_shown')) {
    // Already shown on a previous visit — hide immediately, no animation
    el.style.display = 'none';
    return;
  }

  localStorage.setItem('os_preloader_shown', '1');

  var exited = false;
  function exitPreloader() {
    if (exited) return;
    exited = true;
    el.classList.add('os-exit');
  }

  // Tap / click anywhere on the preloader to skip early
  el.addEventListener('click', exitPreloader);
  el.addEventListener('touchend', exitPreloader, { passive: true });

  // Auto-dismiss after 2s.
  // Module scripts load after window.load on many browsers/devices,
  // so we check readyState instead of blindly adding a load listener.
  function scheduleExit() {
    setTimeout(exitPreloader, 2000);
  }

  if (document.readyState === 'complete') {
    scheduleExit();
  } else {
    window.addEventListener('load', scheduleExit);
  }
})();

